var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mb-10", attrs: { id: "wizard" } },
    [
      _c(
        "v-overlay",
        {
          attrs: {
            color: "#000",
            opacity: "0.40",
            absolute: true,
            value: _vm.isLoading,
            "z-index": 3
          }
        },
        [
          _c("v-progress-circular", {
            staticClass: "mr-10px",
            attrs: { indeterminate: "", color: "primary", size: 60, width: 5 }
          }),
          _vm._v(" " + _vm._s(_vm.loadingMessage) + " ")
        ],
        1
      ),
      _vm.debug
        ? _c(
            "v-card",
            { staticClass: "debug-card pa-2" },
            [
              _c("h2", [_vm._v("Zastupca data")]),
              _c(
                "v-card-actions",
                _vm._l(_vm.zastupcovia, function(zas, i) {
                  return _c(
                    "v-btn",
                    {
                      key: i,
                      staticClass: "btn-secondary",
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          _vm.zasDebugIndex = i
                        }
                      }
                    },
                    [_vm._v(_vm._s(zas.id_zastupcu))]
                  )
                }),
                1
              ),
              _c("v-card-text", [
                _vm.zastupcovia
                  ? _c(
                      "table",
                      _vm._l(_vm.getZastupcoviaDebugEntries(), function(ref) {
                        var key = ref[0]
                        var value = ref[1]
                        return _c("tr", { key: key }, [
                          _c("th", [_vm._v(_vm._s(key) + ":")]),
                          _c("td", { staticClass: "pl-2" }, [
                            _vm._v(_vm._s(value))
                          ])
                        ])
                      }),
                      0
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e(),
      _vm.debug
        ? _c(
            "v-card",
            { staticClass: "debug-card debug-najomca pa-2" },
            [
              _c("h2", [_vm._v("Najomca data")]),
              _c("v-card-text", [
                _c(
                  "table",
                  _vm._l(Object.entries(_vm.najomca), function(ref) {
                    var key = ref[0]
                    var value = ref[1]
                    return _c("tr", { key: key }, [
                      _c("th", [_vm._v(_vm._s(key) + ":")]),
                      _c("td", { staticClass: "pl-2" }, [_vm._v(_vm._s(value))])
                    ])
                  }),
                  0
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-container",
        { staticClass: "pa-0 form-najomca" },
        [
          _c(
            "v-form",
            { ref: "form", attrs: { autocomplete: "off" } },
            [
              _c("h1", { staticClass: "my-25px" }, [_vm._v("Nájomca")]),
              _c(
                "v-card",
                { staticClass: "card" },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { xl: "9", lg: "9", md: "9" } },
                        [
                          _c("button-group", {
                            attrs: {
                              switchBtn: "",
                              data: _vm.formaPodnData,
                              isEnabled: _vm.getNajomcaParameter(
                                "isEnabled",
                                "id_formy_podn"
                              ),
                              required: _vm.getNajomcaParameter(
                                "isRequired",
                                "id_formy_podn"
                              )
                            },
                            model: {
                              value: _vm.najomca.id_formy_podn,
                              callback: function($$v) {
                                _vm.$set(_vm.najomca, "id_formy_podn", $$v)
                              },
                              expression: "najomca.id_formy_podn"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.najomca.id_formy_podn < 3
                    ? _c(
                        "div",
                        {
                          key: _vm.najomca.id_formy_podn,
                          class: { "mt-8": _vm.najomca.id_formy_podn !== 2 }
                        },
                        [
                          _vm.najomca.id_formy_podn === 2
                            ? _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { xl: "4", lg: "4", md: "4" } },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "dynamic_check_box",
                                        attrs: {
                                          label: "Podniká na rodné číslo",
                                          disabled: !_vm.getNajomcaParameter(
                                            "isEnabled",
                                            "podnika_na_rc"
                                          ),
                                          "false-value": 0,
                                          "true-value": 1
                                        },
                                        model: {
                                          value: _vm.najomca.podnika_na_rc,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.najomca,
                                              "podnika_na_rc",
                                              $$v
                                            )
                                          },
                                          expression: "najomca.podnika_na_rc"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.najomca.id_formy_podn === 1 ||
                          (_vm.najomca.id_formy_podn === 2 &&
                            !_vm.najomca.podnika_na_rc)
                            ? _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { xl: "4", lg: "4", md: "4" } },
                                    [
                                      _c("text-box", {
                                        attrs: {
                                          label: "IČO",
                                          isEnabled: _vm.getNajomcaParameter(
                                            "isEnabled",
                                            "ico"
                                          ),
                                          required: _vm.getNajomcaParameter(
                                            "isRequired",
                                            "ico"
                                          ),
                                          removeCharacters: /[^\d]/g
                                        },
                                        model: {
                                          value: _vm.najomca.ico,
                                          callback: function($$v) {
                                            _vm.$set(_vm.najomca, "ico", $$v)
                                          },
                                          expression: "najomca.ico"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { xl: "4", lg: "4", md: "4" } },
                                    [
                                      _c("text-box", {
                                        attrs: {
                                          placeholder: "Obchodné meno nájomcu",
                                          label: "Obchodné meno",
                                          isEnabled: _vm.getNajomcaParameter(
                                            "isEnabled",
                                            "obchod_meno"
                                          ),
                                          required: _vm.getNajomcaParameter(
                                            "isRequired",
                                            "obchod_meno"
                                          )
                                        },
                                        model: {
                                          value: _vm.najomca.obchod_meno,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.najomca,
                                              "obchod_meno",
                                              $$v
                                            )
                                          },
                                          expression: "najomca.obchod_meno"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.najomca.id_formy_podn === 2 &&
                          _vm.najomca.podnika_na_rc
                            ? _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("text-box", {
                                        key: _vm.najomca.id_formy_podn,
                                        attrs: {
                                          label: "Meno",
                                          isEnabled: _vm.getNajomcaParameter(
                                            "isEnabled",
                                            "ine_mena"
                                          ),
                                          required: _vm.getNajomcaParameter(
                                            "isRequired",
                                            "ine_mena"
                                          )
                                        },
                                        model: {
                                          value: _vm.najomca.ine_mena,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.najomca,
                                              "ine_mena",
                                              $$v
                                            )
                                          },
                                          expression: "najomca.ine_mena"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c("text-box", {
                                        key: _vm.najomca.id_formy_podn,
                                        attrs: {
                                          label: "Priezvisko",
                                          isEnabled: _vm.getNajomcaParameter(
                                            "isEnabled",
                                            "obchod_meno"
                                          ),
                                          required: _vm.getNajomcaParameter(
                                            "isRequired",
                                            "obchod_meno"
                                          )
                                        },
                                        model: {
                                          value: _vm.najomca.obchod_meno,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.najomca,
                                              "obchod_meno",
                                              $$v
                                            )
                                          },
                                          expression: "najomca.obchod_meno"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "8" } },
                                [
                                  _c("text-box", {
                                    attrs: {
                                      label: "Registrácia",
                                      isEnabled: _vm.getNajomcaParameter(
                                        "isEnabled",
                                        "registracia"
                                      ),
                                      required: _vm.getNajomcaParameter(
                                        "isRequired",
                                        "registracia"
                                      )
                                    },
                                    model: {
                                      value: _vm.najomca.registracia,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.najomca,
                                          "registracia",
                                          $$v
                                        )
                                      },
                                      expression: "najomca.registracia"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("date-picker", {
                                    attrs: {
                                      label: "Dátum vzniku",
                                      isEnabled: _vm.getNajomcaParameter(
                                        "isEnabled",
                                        "datum_vzniku"
                                      ),
                                      required: _vm.getNajomcaParameter(
                                        "isRequired",
                                        "datum_vzniku"
                                      )
                                    },
                                    model: {
                                      value: _vm.najomca.datum_vzniku,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.najomca,
                                          "datum_vzniku",
                                          $$v
                                        )
                                      },
                                      expression: "najomca.datum_vzniku"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "dynamic_check_box",
                                    attrs: {
                                      label: "Je platca DPH",
                                      disabled: !_vm.getNajomcaParameter(
                                        "isEnabled",
                                        "je_platcom_dph"
                                      ),
                                      "false-value": 0,
                                      "true-value": 1
                                    },
                                    on: {
                                      change: function(v) {
                                        if (!v) {
                                          _vm.najomca.ic_dph = null
                                        }
                                      }
                                    },
                                    model: {
                                      value: _vm.najomca.je_platcom_dph,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.najomca,
                                          "je_platcom_dph",
                                          $$v
                                        )
                                      },
                                      expression: "najomca.je_platcom_dph"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("text-box", {
                                    attrs: {
                                      label: "IČ DPH",
                                      isEnabled:
                                        _vm.getNajomcaParameter(
                                          "isEnabled",
                                          "ic_dph"
                                        ) && !!_vm.najomca.je_platcom_dph,
                                      required: _vm.getNajomcaParameter(
                                        "isRequired",
                                        "ic_dph"
                                      )
                                    },
                                    on: {
                                      input: function(v) {
                                        return (_vm.najomca.dic =
                                          _vm.najomca.ic_dph &&
                                          _vm.najomca.ic_dph.includes("SK")
                                            ? _vm.najomca.ic_dph.replace(
                                                "SK",
                                                ""
                                              )
                                            : _vm.najomca.dic)
                                      }
                                    },
                                    model: {
                                      value: _vm.najomca.ic_dph,
                                      callback: function($$v) {
                                        _vm.$set(_vm.najomca, "ic_dph", $$v)
                                      },
                                      expression: "najomca.ic_dph"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("text-box", {
                                    attrs: {
                                      label: "DIČ",
                                      isEnabled: _vm.getNajomcaParameter(
                                        "isEnabled",
                                        "dic"
                                      ),
                                      required: _vm.getNajomcaParameter(
                                        "isRequired",
                                        "dic"
                                      )
                                    },
                                    model: {
                                      value: _vm.najomca.dic,
                                      callback: function($$v) {
                                        _vm.$set(_vm.najomca, "dic", $$v)
                                      },
                                      expression: "najomca.dic"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _vm.najomca.id_formy_podn === 1
                                    ? _c("v-autocomplete", {
                                        staticClass: "dynamic-input-control",
                                        class: {
                                          required: _vm.getNajomcaParameter(
                                            "isRequired",
                                            "id_pravnej_formy"
                                          )
                                        },
                                        attrs: {
                                          "append-icon": "mdi-chevron-down",
                                          outlined: "",
                                          label: "Právna forma",
                                          rules: [
                                            _vm.getNajomcaParameter(
                                              "isRequired",
                                              "id_pravnej_formy"
                                            )
                                              ? _vm.requiredRule
                                              : true
                                          ],
                                          disabled: !_vm.getNajomcaParameter(
                                            "isEnabled",
                                            "id_pravnej_formy"
                                          ),
                                          items: _vm.pravnaFormaData,
                                          "item-text": "displayMember",
                                          "item-value": "valueMember"
                                        },
                                        model: {
                                          value: _vm.najomca.id_pravnej_formy,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.najomca,
                                              "id_pravnej_formy",
                                              $$v
                                            )
                                          },
                                          expression: "najomca.id_pravnej_formy"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm.najomca.id_formy_podn === 2
                                    ? _c("v-autocomplete", {
                                        staticClass: "dynamic-input-control",
                                        class: {
                                          required: _vm.getNajomcaParameter(
                                            "isRequired",
                                            "id_koncesie"
                                          )
                                        },
                                        attrs: {
                                          "append-icon": "mdi-chevron-down",
                                          outlined: "",
                                          label: "Koncesia",
                                          disabled: !_vm.getNajomcaParameter(
                                            "isEnabled",
                                            "id_koncesie"
                                          ),
                                          rules: [
                                            _vm.getNajomcaParameter(
                                              "isRequired",
                                              "id_koncesie"
                                            )
                                              ? _vm.requiredRule
                                              : true
                                          ],
                                          items: _vm.koncesiaData,
                                          "item-text": "displayMember",
                                          "item-value": "valueMember"
                                        },
                                        model: {
                                          value: _vm.najomca.id_koncesie,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.najomca,
                                              "id_koncesie",
                                              $$v
                                            )
                                          },
                                          expression: "najomca.id_koncesie"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("text-box", {
                                    ref: "iban",
                                    attrs: {
                                      label: "IBAN",
                                      isEnabled: _vm.getNajomcaParameter(
                                        "isEnabled",
                                        "iban"
                                      ),
                                      required: _vm.getNajomcaParameter(
                                        "isRequired",
                                        "iban"
                                      )
                                    },
                                    on: {
                                      input: function(v) {
                                        return _vm.checkCorrectnessIban(v)
                                      }
                                    },
                                    model: {
                                      value: _vm.najomca.iban,
                                      callback: function($$v) {
                                        _vm.$set(_vm.najomca, "iban", $$v)
                                      },
                                      expression: "najomca.iban"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "8" } },
                                [
                                  _c("text-box", {
                                    attrs: {
                                      label:
                                        "Charakteristika predmetu podnikania",
                                      isEnabled: _vm.getNajomcaParameter(
                                        "isEnabled",
                                        "oblast_podn_nace_nazov"
                                      ),
                                      required: _vm.getNajomcaParameter(
                                        "isRequired",
                                        "oblast_podn_nace_nazov"
                                      )
                                    },
                                    model: {
                                      value: _vm.najomca.oblast_podn_nace_nazov,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.najomca,
                                          "oblast_podn_nace_nazov",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "najomca.oblast_podn_nace_nazov"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("text-box", {
                                    attrs: {
                                      label: "Počet zamestnancov",
                                      isEnabled: _vm.getNajomcaParameter(
                                        "isEnabled",
                                        "pocet_zamestnancov"
                                      ),
                                      required: _vm.getNajomcaParameter(
                                        "isRequired",
                                        "pocet_zamestnancov"
                                      )
                                    },
                                    model: {
                                      value: _vm.najomca.pocet_zamestnancov,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.najomca,
                                          "pocet_zamestnancov",
                                          $$v
                                        )
                                      },
                                      expression: "najomca.pocet_zamestnancov"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "dynamic-input-control",
                                    class: {
                                      required: _vm.getNajomcaParameter(
                                        "isRequired",
                                        "id_zdroja_fin_prostriedkov"
                                      )
                                    },
                                    attrs: {
                                      "append-icon": "mdi-chevron-down",
                                      outlined: "",
                                      label: "Zdroj finančných prostriedkov",
                                      rules: [
                                        _vm.getNajomcaParameter(
                                          "isRequired",
                                          "id_zdroja_fin_prostriedkov"
                                        )
                                          ? _vm.requiredRule
                                          : true
                                      ],
                                      disabled: !_vm.getNajomcaParameter(
                                        "isEnabled",
                                        "id_zdroja_fin_prostriedkov"
                                      ),
                                      items: _vm.zdrojFinProstredkovData,
                                      "item-text": "displayMember",
                                      "item-value": "valueMember"
                                    },
                                    model: {
                                      value:
                                        _vm.najomca.id_zdroja_fin_prostriedkov,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.najomca,
                                          "id_zdroja_fin_prostriedkov",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "najomca.id_zdroja_fin_prostriedkov"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.najomca.id_formy_podn === 3
                    ? _c(
                        "div",
                        { staticClass: "mt-8" },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("text-box", {
                                    attrs: {
                                      label: "Meno",
                                      isEnabled: _vm.getNajomcaParameter(
                                        "isEnabled",
                                        "ine_mena"
                                      ),
                                      required: _vm.getNajomcaParameter(
                                        "isRequired",
                                        "ine_mena"
                                      )
                                    },
                                    model: {
                                      value: _vm.najomca.ine_mena,
                                      callback: function($$v) {
                                        _vm.$set(_vm.najomca, "ine_mena", $$v)
                                      },
                                      expression: "najomca.ine_mena"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("text-box", {
                                    attrs: {
                                      label: "Priezvisko",
                                      isEnabled: _vm.getNajomcaParameter(
                                        "isEnabled",
                                        "obchod_meno"
                                      ),
                                      required: _vm.getNajomcaParameter(
                                        "isRequired",
                                        "obchod_meno"
                                      )
                                    },
                                    model: {
                                      value: _vm.najomca.obchod_meno,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.najomca,
                                          "obchod_meno",
                                          $$v
                                        )
                                      },
                                      expression: "najomca.obchod_meno"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("text-box", {
                                    ref: "iban",
                                    attrs: {
                                      label: "IBAN",
                                      isEnabled: _vm.getNajomcaParameter(
                                        "isEnabled",
                                        "iban"
                                      ),
                                      required: _vm.getNajomcaParameter(
                                        "isRequired",
                                        "iban"
                                      )
                                    },
                                    on: {
                                      input: function(v) {
                                        return _vm.checkCorrectnessIban(v)
                                      }
                                    },
                                    model: {
                                      value: _vm.najomca.iban,
                                      callback: function($$v) {
                                        _vm.$set(_vm.najomca, "iban", $$v)
                                      },
                                      expression: "najomca.iban"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.najomca.id_formy_podn === 1 ||
              (_vm.najomca.id_formy_podn === 2 && !_vm.najomca.podnika_na_rc)
                ? _c(
                    "v-card",
                    { staticClass: "mt-6 card" },
                    [
                      _c("h2", { staticClass: "mb-6" }, [
                        _vm._v("Sídlo firmy")
                      ]),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c("text-box", {
                                attrs: {
                                  label: "Ulica",
                                  isEnabled: _vm.getNajomcaParameter(
                                    "isEnabled",
                                    "ulica_reg"
                                  ),
                                  required: _vm.getNajomcaParameter(
                                    "isRequired",
                                    "ulica_reg"
                                  )
                                },
                                model: {
                                  value: _vm.najomca.ulica_reg,
                                  callback: function($$v) {
                                    _vm.$set(_vm.najomca, "ulica_reg", $$v)
                                  },
                                  expression: "najomca.ulica_reg"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c("text-box", {
                                attrs: {
                                  label: "Číslo domu",
                                  isEnabled: _vm.getNajomcaParameter(
                                    "isEnabled",
                                    "cislo_domu_reg"
                                  ),
                                  required: _vm.getNajomcaParameter(
                                    "isRequired",
                                    "cislo_domu_reg"
                                  )
                                },
                                model: {
                                  value: _vm.najomca.cislo_domu_reg,
                                  callback: function($$v) {
                                    _vm.$set(_vm.najomca, "cislo_domu_reg", $$v)
                                  },
                                  expression: "najomca.cislo_domu_reg"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c("text-box", {
                                attrs: {
                                  label: "Mesto/obec",
                                  isEnabled: _vm.getNajomcaParameter(
                                    "isEnabled",
                                    "mesto_reg"
                                  ),
                                  required: _vm.getNajomcaParameter(
                                    "isRequired",
                                    "mesto_reg"
                                  )
                                },
                                model: {
                                  value: _vm.najomca.mesto_reg,
                                  callback: function($$v) {
                                    _vm.$set(_vm.najomca, "mesto_reg", $$v)
                                  },
                                  expression: "najomca.mesto_reg"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c("text-box", {
                                attrs: {
                                  label: "PSČ",
                                  isEnabled: _vm.getNajomcaParameter(
                                    "isEnabled",
                                    "psc_reg"
                                  ),
                                  required: _vm.getNajomcaParameter(
                                    "isRequired",
                                    "psc_reg"
                                  )
                                },
                                model: {
                                  value: _vm.najomca.psc_reg,
                                  callback: function($$v) {
                                    _vm.$set(_vm.najomca, "psc_reg", $$v)
                                  },
                                  expression: "najomca.psc_reg"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "8" } },
                            [
                              _c("v-autocomplete", {
                                staticClass: "dynamic-input-control",
                                class: {
                                  required: _vm.getNajomcaParameter(
                                    "isRequired",
                                    "stat_reg"
                                  )
                                },
                                attrs: {
                                  "append-icon": "mdi-chevron-down",
                                  outlined: "",
                                  label: "Štát",
                                  rules: [
                                    _vm.getNajomcaParameter(
                                      "isRequired",
                                      "stat_reg"
                                    )
                                      ? _vm.requiredRule
                                      : true
                                  ],
                                  disabled: !_vm.getNajomcaParameter(
                                    "isEnabled",
                                    "stat_reg"
                                  ),
                                  items: _vm.statyData,
                                  "item-text": "displayMember",
                                  "item-value": "valueMember"
                                },
                                model: {
                                  value: _vm.najomca.stat_reg,
                                  callback: function($$v) {
                                    _vm.$set(_vm.najomca, "stat_reg", $$v)
                                  },
                                  expression: "najomca.stat_reg"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.najomca.adresa_kor_visible &&
              (_vm.najomca.id_formy_podn === 1 ||
                (_vm.najomca.id_formy_podn === 2 && !_vm.najomca.podnika_na_rc))
                ? _c(
                    "v-card",
                    { staticClass: "mt-6 card" },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex" },
                        [
                          _c("h2", [_vm._v("Korešpondenčná adresa")]),
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn-secondary ml-auto",
                              attrs: { icon: "" },
                              on: {
                                click: function($event) {
                                  _vm.showKor = !_vm.showKor
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { class: { "rotate-180": _vm.showKor } },
                                [_vm._v("mdi-chevron-down")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-expand-transition", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showKor,
                                expression: "showKor"
                              }
                            ],
                            staticClass: "mt-6"
                          },
                          [
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _c("text-box", {
                                      attrs: {
                                        label: "Ulica",
                                        isEnabled: _vm.getNajomcaParameter(
                                          "isEnabled",
                                          "ulica_kor"
                                        ),
                                        required: _vm.getNajomcaParameter(
                                          "isRequired",
                                          "ulica_kor"
                                        )
                                      },
                                      model: {
                                        value: _vm.najomca.ulica_kor,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.najomca,
                                            "ulica_kor",
                                            $$v
                                          )
                                        },
                                        expression: "najomca.ulica_kor"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _c("text-box", {
                                      attrs: {
                                        label: "Číslo domu",
                                        isEnabled: _vm.getNajomcaParameter(
                                          "isEnabled",
                                          "cislo_domu_kor"
                                        ),
                                        required: _vm.getNajomcaParameter(
                                          "isRequired",
                                          "cislo_domu_kor"
                                        )
                                      },
                                      model: {
                                        value: _vm.najomca.cislo_domu_kor,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.najomca,
                                            "cislo_domu_kor",
                                            $$v
                                          )
                                        },
                                        expression: "najomca.cislo_domu_kor"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _c("text-box", {
                                      attrs: {
                                        label: "Mesto/obec",
                                        isEnabled: _vm.getNajomcaParameter(
                                          "isEnabled",
                                          "mesto_kor"
                                        ),
                                        required: _vm.getNajomcaParameter(
                                          "isRequired",
                                          "mesto_kor"
                                        )
                                      },
                                      model: {
                                        value: _vm.najomca.mesto_kor,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.najomca,
                                            "mesto_kor",
                                            $$v
                                          )
                                        },
                                        expression: "najomca.mesto_kor"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "4" } },
                                  [
                                    _c("text-box", {
                                      attrs: {
                                        label: "PSČ",
                                        isEnabled: _vm.getNajomcaParameter(
                                          "isEnabled",
                                          "psc_kor"
                                        ),
                                        required: _vm.getNajomcaParameter(
                                          "isRequired",
                                          "psc_kor"
                                        )
                                      },
                                      model: {
                                        value: _vm.najomca.psc_kor,
                                        callback: function($$v) {
                                          _vm.$set(_vm.najomca, "psc_kor", $$v)
                                        },
                                        expression: "najomca.psc_kor"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "8" } },
                                  [
                                    _c("v-autocomplete", {
                                      staticClass: "dynamic-input-control",
                                      class: {
                                        required: _vm.getNajomcaParameter(
                                          "isRequired",
                                          "stat_kor"
                                        )
                                      },
                                      attrs: {
                                        "append-icon": "mdi-chevron-down",
                                        outlined: "",
                                        label: "Štát",
                                        rules: [
                                          _vm.getNajomcaParameter(
                                            "isRequired",
                                            "stat_kor"
                                          )
                                            ? _vm.requiredRule
                                            : true
                                        ],
                                        disabled: !_vm.getNajomcaParameter(
                                          "isEnabled",
                                          "stat_kor"
                                        ),
                                        items: _vm.statyData,
                                        "item-text": "displayMember",
                                        "item-value": "valueMember"
                                      },
                                      model: {
                                        value: _vm.najomca.stat_kor,
                                        callback: function($$v) {
                                          _vm.$set(_vm.najomca, "stat_kor", $$v)
                                        },
                                        expression: "najomca.stat_kor"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._l(_vm.zastupcovia, function(zas) {
            return _c(
              "v-card",
              {
                key: zas.id_zastupcu,
                staticClass: "mt-6 card",
                attrs: { id: "zastupca" + zas.id_zastupcu }
              },
              [
                _c(
                  "div",
                  { staticClass: "d-flex" },
                  [
                    _c("h2", { staticClass: "mr-15px" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            zas.id_zastupcu > 0
                              ? zas.meno + " " + zas.priezvisko
                              : "Nová kontaktná osoba"
                          ) +
                          " "
                      )
                    ]),
                    zas.id_zastupcu > 0
                      ? [
                          zas.cislo_dokladu
                            ? _c(
                                "span",
                                { staticClass: "mr-15px f14 my-auto" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-5px gs100",
                                      attrs: { size: "18" }
                                    },
                                    [_vm._v("mdi-card-account-details-outline")]
                                  ),
                                  _vm._v(_vm._s(zas.cislo_dokladu) + " ")
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.getAdresa(zas)
                            ? _c(
                                "span",
                                { staticClass: "f14 my-auto" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-5px gs100",
                                      attrs: { size: "18" }
                                    },
                                    [_vm._v("mdi-home-city-outline")]
                                  ),
                                  _vm._v(_vm._s(_vm.getAdresa(zas)) + " ")
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      : _vm._e(),
                    zas.id_zastupcu < 0
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "btn-terciary ml-auto mr-3",
                            attrs: { icon: "" },
                            on: {
                              click: function($event) {
                                return _vm.removeZastupca(zas)
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { size: "20" } }, [
                              _vm._v("mdi-trash-can-outline")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "v-btn",
                      {
                        staticClass: "btn-secondary",
                        class: { "ml-auto": zas.id_zastupcu > 0 },
                        attrs: { icon: "" },
                        on: {
                          click: function($event) {
                            return _vm.openCloseZastupca(zas)
                          }
                        }
                      },
                      [
                        _c("v-icon", { class: { "rotate-180": zas.show } }, [
                          _vm._v("mdi-chevron-down")
                        ])
                      ],
                      1
                    )
                  ],
                  2
                ),
                _c("v-expand-transition", [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: zas.show,
                          expression: "zas.show"
                        }
                      ]
                    },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form_manual_" + zas.id_zastupcu,
                          refInFor: true,
                          attrs: { autocomplete: "off" }
                        },
                        [
                          _c(
                            "v-row",
                            { staticClass: "mt-6" },
                            [
                              _vm.najomca.id_formy_podn == 1
                                ? _c(
                                    "v-col",
                                    { attrs: { xl: "4", lg: "4", md: "4" } },
                                    [
                                      _c("v-autocomplete", {
                                        staticClass: "dynamic-input-control",
                                        class: {
                                          required: _vm.getZastupcaParameter(
                                            "isRequired",
                                            "id_funkcie",
                                            zas.id_zastupcu
                                          )
                                        },
                                        attrs: {
                                          "append-icon": "mdi-chevron-down",
                                          outlined: "",
                                          label: "Funkcia",
                                          rules: [
                                            _vm.getZastupcaParameter(
                                              "isRequired",
                                              "id_funkcie",
                                              zas.id_zastupcu
                                            )
                                              ? _vm.requiredRule
                                              : true
                                          ],
                                          items: _vm.funkcieData,
                                          "item-text": "displayMember",
                                          "item-value": "valueMember",
                                          disabled: !_vm.getZastupcaParameter(
                                            "isEnabled",
                                            "id_funkcie",
                                            zas.id_zastupcu
                                          )
                                        },
                                        model: {
                                          value: zas.id_funkcie,
                                          callback: function($$v) {
                                            _vm.$set(zas, "id_funkcie", $$v)
                                          },
                                          expression: "zas.id_funkcie"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-col",
                                { attrs: { xl: "4", lg: "4", md: "4" } },
                                [
                                  _c("text-box", {
                                    attrs: {
                                      label: "Email",
                                      placeholder: "@",
                                      isEnabled: _vm.getZastupcaParameter(
                                        "isEnabled",
                                        "email",
                                        zas.id_zastupcu
                                      ),
                                      required: _vm.getZastupcaParameter(
                                        "isRequired",
                                        "email",
                                        zas.id_zastupcu
                                      ),
                                      rules: [
                                        function(v) {
                                          return (
                                            _vm.emailRegex.test(v) ||
                                            !zas.email ||
                                            !v ||
                                            "Nesprávny formát e-mailovej adresy"
                                          )
                                        }
                                      ]
                                    },
                                    on: {
                                      change: function() {
                                        return _vm.checkProfilVKZ(zas)
                                      }
                                    },
                                    model: {
                                      value: zas.email,
                                      callback: function($$v) {
                                        _vm.$set(zas, "email", $$v)
                                      },
                                      expression: "zas.email"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { xl: "4", lg: "4", md: "4" } },
                                [
                                  _c("text-box", {
                                    ref: "telefon",
                                    refInFor: true,
                                    attrs: {
                                      label: "Telefón",
                                      placeholder: "+421",
                                      rules: [_vm.telefonneCisloRule],
                                      isEnabled: _vm.getZastupcaParameter(
                                        "isEnabled",
                                        "mobil",
                                        zas.id_zastupcu
                                      ),
                                      required: _vm.getZastupcaParameter(
                                        "isRequired",
                                        "mobil",
                                        zas.id_zastupcu
                                      ),
                                      textOnFocus: "+421",
                                      removeCharacters: /[^+\d]/g,
                                      isPhoneNumber: true
                                    },
                                    model: {
                                      value: zas.mobil,
                                      callback: function($$v) {
                                        _vm.$set(zas, "mobil", $$v)
                                      },
                                      expression: "zas.mobil"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _vm.najomca.id_formy_podn == 1 ||
                              _vm.najomca.id_formy_podn == 2
                                ? _c(
                                    "v-col",
                                    {
                                      staticStyle: { height: "70px" },
                                      attrs: { xl: "3", lg: "3", md: "3" }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "dynamic_check_box",
                                        attrs: {
                                          label: "Konečný užívateľ výhod",
                                          disabled: !_vm.getZastupcaParameter(
                                            "isEnabled",
                                            "konecny_uzivatel_vyhod",
                                            zas.id_zastupcu
                                          ),
                                          "false-value": 0,
                                          "true-value": 1
                                        },
                                        model: {
                                          value: zas.konecny_uzivatel_vyhod,
                                          callback: function($$v) {
                                            _vm.$set(
                                              zas,
                                              "konecny_uzivatel_vyhod",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "zas.konecny_uzivatel_vyhod"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.najomca.id_formy_podn == 1 ||
                              _vm.najomca.id_formy_podn == 2
                                ? _c(
                                    "v-col",
                                    { attrs: { xl: "3", lg: "3", md: "3" } },
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "dynamic_check_box",
                                        attrs: {
                                          label: "Štatutárny zástupca",
                                          disabled: !_vm.getZastupcaParameter(
                                            "isEnabled",
                                            "je_konatel",
                                            zas.id_zastupcu
                                          ),
                                          "false-value": 0,
                                          "true-value": 1
                                        },
                                        model: {
                                          value: zas.je_konatel,
                                          callback: function($$v) {
                                            _vm.$set(zas, "je_konatel", $$v)
                                          },
                                          expression: "zas.je_konatel"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-col",
                                { attrs: { xl: "3", lg: "3", md: "3" } },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "dynamic_check_box",
                                    attrs: {
                                      label: "Zahraničná osoba",
                                      disabled: !_vm.getZastupcaParameter(
                                        "isEnabled",
                                        "zahranicna_osoba",
                                        zas.id_zastupcu
                                      ),
                                      "false-value": 0,
                                      "true-value": 1
                                    },
                                    on: {
                                      change: function(val) {
                                        return _vm.nastavObcianstvo(val, zas)
                                      }
                                    },
                                    model: {
                                      value: zas.zahranicna_osoba,
                                      callback: function($$v) {
                                        _vm.$set(zas, "zahranicna_osoba", $$v)
                                      },
                                      expression: "zas.zahranicna_osoba"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { xl: "3", lg: "3", md: "3" } },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "dynamic_check_box",
                                    attrs: {
                                      label: "Profil v KZ",
                                      disabled: !_vm.getZastupcaParameter(
                                        "isEnabled",
                                        "ma_profil_kz",
                                        zas.id_zastupcu
                                      ),
                                      "false-value": 0,
                                      "true-value": 1
                                    },
                                    model: {
                                      value: zas.ma_profil_kz,
                                      callback: function($$v) {
                                        _vm.$set(zas, "ma_profil_kz", $$v)
                                      },
                                      expression: "zas.ma_profil_kz"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            {
                              staticClass: "mb-8",
                              staticStyle: { "align-items": "center" }
                            },
                            [
                              _c(
                                "v-col",
                                { staticClass: "col-auto" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "btn-primary",
                                      attrs: {
                                        disabled:
                                          _vm.sendingRequest ||
                                          !zas.email ||
                                          _vm.idVytazenia != null
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.setIdentityTB(zas)
                                        }
                                      }
                                    },
                                    [_vm._v(" Odoslať Identity TB ")]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "btn-primary ml-5",
                                      attrs: {
                                        disabled:
                                          !zas.email ||
                                          !zas.mobil ||
                                          _vm.sendingRequest ||
                                          _vm.idVytazenia != null
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.confirmAndSendOp(zas)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " Nahrať " +
                                          _vm._s(
                                            zas.zahranicnaOsoba
                                              ? "doklad"
                                              : "OP"
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "btn-primary ml-5",
                                      attrs: {
                                        disabled:
                                          !zas.email ||
                                          !zas.mobil ||
                                          _vm.sendingRequest ||
                                          _vm.idVytazenia != null
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.confirmAndOpenSendOpMobilDialog(
                                            zas
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " Odfotiť " +
                                          _vm._s(
                                            zas.zahranicnaOsoba
                                              ? "doklad"
                                              : "OP"
                                          ) +
                                          " cez MT "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "btn-secondary ml-5",
                                      on: {
                                        click: function($event) {
                                          zas.zadatOpManualne = !zas.zadatOpManualne
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " Zadať " +
                                          _vm._s(
                                            zas.zahranicna_osoba
                                              ? "doklad"
                                              : "OP"
                                          ) +
                                          " manuálne "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "col-auto" },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "dynamic_check_box",
                                    attrs: {
                                      label: "Fyzické overenie",
                                      disabled: !_vm.getZastupcaParameter(
                                        "isEnabled",
                                        "fyzicky_overeny",
                                        zas.id_zastupcu
                                      ),
                                      "false-value": 0,
                                      "true-value": 1
                                    },
                                    on: {
                                      change: function(val) {
                                        return _vm.nastavFyzickeOverenie(
                                          val,
                                          zas
                                        )
                                      }
                                    },
                                    model: {
                                      value: zas.fyzicky_overeny,
                                      callback: function($$v) {
                                        _vm.$set(zas, "fyzicky_overeny", $$v)
                                      },
                                      expression: "zas.fyzicky_overeny"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: zas.zadatOpManualne,
                                  expression: "zas.zadatOpManualne"
                                }
                              ]
                            },
                            [
                              _c(
                                "v-row",
                                { staticClass: "mt-8" },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { xl: "4", lg: "4", md: "4" } },
                                    [
                                      _c("v-autocomplete", {
                                        staticClass: "dynamic-input-control",
                                        class: {
                                          required: _vm.getZastupcaParameter(
                                            "isRequired",
                                            "titul_1",
                                            zas.id_zastupcu
                                          )
                                        },
                                        attrs: {
                                          "append-icon": "mdi-chevron-down",
                                          outlined: "",
                                          label: "Titul",
                                          items: _vm.titul1Data,
                                          "item-text": "displayMember",
                                          "item-value": "valueMember",
                                          rules: [
                                            _vm.getZastupcaParameter(
                                              "isRequired",
                                              "titul_1",
                                              zas.id_zastupcu
                                            )
                                              ? _vm.requiredRule
                                              : true
                                          ],
                                          disabled: !_vm.getZastupcaParameter(
                                            "isEnabled",
                                            "titul_1",
                                            zas.id_zastupcu
                                          )
                                        },
                                        model: {
                                          value: zas.titul_1,
                                          callback: function($$v) {
                                            _vm.$set(zas, "titul_1", $$v)
                                          },
                                          expression: "zas.titul_1"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { xl: "4", lg: "4", md: "4" } },
                                    [
                                      _c("v-autocomplete", {
                                        staticClass: "dynamic-input-control",
                                        class: {
                                          required: _vm.getZastupcaParameter(
                                            "isRequired",
                                            "pohlavie",
                                            zas.id_zastupcu
                                          )
                                        },
                                        attrs: {
                                          "append-icon": "mdi-chevron-down",
                                          outlined: "",
                                          label: "Pohlavie",
                                          rules: [
                                            _vm.getZastupcaParameter(
                                              "isRequired",
                                              "pohlavie",
                                              zas.id_zastupcu
                                            )
                                              ? _vm.requiredRule
                                              : true
                                          ],
                                          items: _vm.pohlaviaData,
                                          "item-text": "displayMember",
                                          "item-value": "valueMember",
                                          disabled: !_vm.getZastupcaParameter(
                                            "isEnabled",
                                            "pohlavie",
                                            zas.id_zastupcu
                                          )
                                        },
                                        model: {
                                          value: zas.pohlavie,
                                          callback: function($$v) {
                                            _vm.$set(zas, "pohlavie", $$v)
                                          },
                                          expression: "zas.pohlavie"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { xl: "4", lg: "4", md: "4" } },
                                    [
                                      _c("text-box", {
                                        attrs: {
                                          label: "Meno",
                                          placeholder: "Meno kontaktnej osoby",
                                          isEnabled: _vm.getZastupcaParameter(
                                            "isEnabled",
                                            "meno",
                                            zas.id_zastupcu
                                          ),
                                          required: _vm.getZastupcaParameter(
                                            "isRequired",
                                            "meno",
                                            zas.id_zastupcu
                                          )
                                        },
                                        model: {
                                          value: zas.meno,
                                          callback: function($$v) {
                                            _vm.$set(zas, "meno", $$v)
                                          },
                                          expression: "zas.meno"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { xl: "4", lg: "4", md: "4" } },
                                    [
                                      _c("text-box", {
                                        attrs: {
                                          label: "Priezvisko",
                                          placeholder:
                                            "Priezvisko kontaktnej osoby",
                                          isEnabled: _vm.getZastupcaParameter(
                                            "isEnabled",
                                            "priezvisko",
                                            zas.id_zastupcu
                                          ),
                                          required: _vm.getZastupcaParameter(
                                            "isRequired",
                                            "priezvisko",
                                            zas.id_zastupcu
                                          )
                                        },
                                        model: {
                                          value: zas.priezvisko,
                                          callback: function($$v) {
                                            _vm.$set(zas, "priezvisko", $$v)
                                          },
                                          expression: "zas.priezvisko"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { xl: "4", lg: "4", md: "4" } },
                                    [
                                      _c("DatePicker", {
                                        attrs: {
                                          label: "Dátum narodenia",
                                          placeholder: "DD/MM/YYYY",
                                          isEnabled: _vm.getZastupcaParameter(
                                            "isEnabled",
                                            "datum_narodenia",
                                            zas.id_zastupcu
                                          ),
                                          required: _vm.getZastupcaParameter(
                                            "isRequired",
                                            "datum_narodenia",
                                            zas.id_zastupcu
                                          )
                                        },
                                        model: {
                                          value: zas.datum_narodenia,
                                          callback: function($$v) {
                                            _vm.$set(
                                              zas,
                                              "datum_narodenia",
                                              $$v
                                            )
                                          },
                                          expression: "zas.datum_narodenia"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { xl: "4", lg: "4", md: "4" } },
                                    [
                                      _c("v-autocomplete", {
                                        staticClass: "dynamic-input-control",
                                        class: {
                                          required: _vm.getZastupcaParameter(
                                            "isRequired",
                                            "id_krajiny_dokladu",
                                            zas.id_zastupcu
                                          )
                                        },
                                        attrs: {
                                          "append-icon": "mdi-chevron-down",
                                          outlined: "",
                                          rules: [
                                            _vm.getZastupcaParameter(
                                              "isRequired",
                                              "id_krajiny_dokladu",
                                              zas.id_zastupcu
                                            )
                                              ? _vm.requiredRule
                                              : true,
                                            function(v) {
                                              return _vm.statnaPrislusnostRule(
                                                v,
                                                zas
                                              )
                                            }
                                          ],
                                          label: zas.zahranicna_osoba
                                            ? "Štátna príslušnosť"
                                            : "Štátne občianstvo",
                                          items: _vm.statyData,
                                          "item-text": "displayMember",
                                          "item-value": "valueMember",
                                          disabled: !_vm.getZastupcaParameter(
                                            "isEnabled",
                                            "id_krajiny_dokladu",
                                            zas.id_zastupcu
                                          )
                                        },
                                        model: {
                                          value: zas.id_krajiny_dokladu,
                                          callback: function($$v) {
                                            _vm.$set(
                                              zas,
                                              "id_krajiny_dokladu",
                                              $$v
                                            )
                                          },
                                          expression: "zas.id_krajiny_dokladu"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { xl: "4", lg: "4", md: "4" } },
                                    [
                                      _c("text-box", {
                                        key: zas.rc,
                                        attrs: {
                                          rodneCislo: !zas.zahranicna_osoba,
                                          staticLabel: zas.zahranicna_osoba
                                            ? "Identifikačné číslo"
                                            : "Rodné číslo",
                                          placeholder: "rdč. bez /",
                                          isEnabled: _vm.getZastupcaParameter(
                                            "isEnabled",
                                            "rc",
                                            zas.id_zastupcu
                                          ),
                                          required: _vm.getZastupcaParameter(
                                            "isRequired",
                                            "rc",
                                            zas.id_zastupcu
                                          )
                                        },
                                        on: {
                                          input: function(v) {
                                            return _vm.onRodneCisloInput(v, zas)
                                          }
                                        },
                                        model: {
                                          value: zas.rc,
                                          callback: function($$v) {
                                            _vm.$set(zas, "rc", $$v)
                                          },
                                          expression: "zas.rc"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { xl: "4", lg: "4", md: "4" } },
                                    [
                                      _c("text-box", {
                                        attrs: {
                                          staticLabel: zas.zahranicna_osoba
                                            ? "Číslo dokladu"
                                            : "Číslo OP",
                                          placeholder: "XX123456",
                                          isEnabled: _vm.getZastupcaParameter(
                                            "isEnabled",
                                            "cislo_dokladu",
                                            zas.id_zastupcu
                                          ),
                                          required: _vm.getZastupcaParameter(
                                            "isRequired",
                                            "cislo_dokladu",
                                            zas.id_zastupcu
                                          )
                                        },
                                        model: {
                                          value: zas.cislo_dokladu,
                                          callback: function($$v) {
                                            _vm.$set(zas, "cislo_dokladu", $$v)
                                          },
                                          expression: "zas.cislo_dokladu"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { xl: "4", lg: "4", md: "4" } },
                                    [
                                      _c("DatePicker", {
                                        attrs: {
                                          label: "Dátum vydania",
                                          placeholder: "DD/MM/YYYY",
                                          isEnabled: _vm.getZastupcaParameter(
                                            "isEnabled",
                                            "platnost_od",
                                            zas.id_zastupcu
                                          ),
                                          required: _vm.getZastupcaParameter(
                                            "isRequired",
                                            "platnost_od",
                                            zas.id_zastupcu
                                          )
                                        },
                                        on: {
                                          inputChanged: function(v) {
                                            return _vm.updateDatumPlatnosti(
                                              v,
                                              zas
                                            )
                                          }
                                        },
                                        model: {
                                          value: zas.platnost_od,
                                          callback: function($$v) {
                                            _vm.$set(zas, "platnost_od", $$v)
                                          },
                                          expression: "zas.platnost_od"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { xl: "4", lg: "4", md: "4" } },
                                    [
                                      _c("DatePicker", {
                                        attrs: {
                                          staticLabel: zas.zahranicna_osoba
                                            ? "Platnosť do"
                                            : "Dátum platnosti",
                                          placeholder: "DD/MM/YYYY",
                                          isEnabled: _vm.getZastupcaParameter(
                                            "isEnabled",
                                            "platnost_do",
                                            zas.id_zastupcu
                                          ),
                                          required: _vm.getZastupcaParameter(
                                            "isRequired",
                                            "platnost_do",
                                            zas.id_zastupcu
                                          )
                                        },
                                        model: {
                                          value: zas.platnost_do,
                                          callback: function($$v) {
                                            _vm.$set(zas, "platnost_do", $$v)
                                          },
                                          expression: "zas.platnost_do"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { xl: "4", lg: "4", md: "4" } },
                                    [
                                      _c("v-combobox", {
                                        staticClass: "dynamic-input-control",
                                        class: {
                                          required: _vm.getZastupcaParameter(
                                            "isRequired",
                                            "mesto",
                                            zas.id_zastupcu
                                          )
                                        },
                                        attrs: {
                                          label: "Mesto/obec",
                                          "append-icon": "mdi-chevron-down",
                                          outlined: "",
                                          items: zas.mestoSearchData,
                                          loading: zas.mestoSearchLoading.value,
                                          "no-filter": "",
                                          clearable: "",
                                          "item-text": "displayMember",
                                          "item-value": "valueMember",
                                          "return-object": "",
                                          disabled: !_vm.getZastupcaParameter(
                                            "isEnabled",
                                            "mesto",
                                            zas.id_zastupcu
                                          ),
                                          rules: [
                                            _vm.getZastupcaParameter(
                                              "isRequired",
                                              "mesto",
                                              zas.id_zastupcu
                                            )
                                              ? _vm.requiredRule
                                              : true
                                          ]
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.cityOnChange($event, zas)
                                          },
                                          "update:search-input": function(
                                            $event
                                          ) {
                                            return _vm.searchCity(
                                              $event,
                                              zas,
                                              3
                                            )
                                          }
                                        },
                                        model: {
                                          value: zas.mesto,
                                          callback: function($$v) {
                                            _vm.$set(zas, "mesto", $$v)
                                          },
                                          expression: "zas.mesto"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { xl: "4", lg: "4", md: "4" } },
                                    [
                                      _c("v-combobox", {
                                        staticClass: "dynamic-input-control",
                                        class: {
                                          required: _vm.getZastupcaParameter(
                                            "isRequired",
                                            "ulica",
                                            zas.id_zastupcu
                                          )
                                        },
                                        attrs: {
                                          label: "Ulica",
                                          "append-icon": "mdi-chevron-down",
                                          outlined: "",
                                          items: zas.ulicaSearchData,
                                          loading: zas.ulicaSearchLoading.value,
                                          "no-filter": "",
                                          "item-text": "displayMember",
                                          "item-value": "valueMember",
                                          clearable: "",
                                          "return-object": "",
                                          disabled: !_vm.getZastupcaParameter(
                                            "isEnabled",
                                            "ulica",
                                            zas.id_zastupcu
                                          ),
                                          rules: [
                                            _vm.getZastupcaParameter(
                                              "isRequired",
                                              "ulica",
                                              zas.id_zastupcu
                                            )
                                              ? _vm.requiredRule
                                              : true
                                          ]
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.streetOnChange(
                                              $event,
                                              zas
                                            )
                                          },
                                          "update:search-input": function(
                                            $event
                                          ) {
                                            return _vm.searchStreets(
                                              $event,
                                              zas,
                                              3
                                            )
                                          }
                                        },
                                        model: {
                                          value: zas.ulica,
                                          callback: function($$v) {
                                            _vm.$set(zas, "ulica", $$v)
                                          },
                                          expression: "zas.ulica"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { xl: "4", lg: "4", md: "4" } },
                                    [
                                      _c("v-combobox", {
                                        staticClass: "dynamic-input-control",
                                        class: {
                                          required: _vm.getZastupcaParameter(
                                            "isRequired",
                                            "cislo_domu",
                                            zas.id_zastupcu
                                          )
                                        },
                                        attrs: {
                                          label: "Číslo domu",
                                          "append-icon": "mdi-chevron-down",
                                          outlined: "",
                                          items: zas.cislo_domuSearchData,
                                          loading:
                                            zas.cislo_domuSearchLoading.value,
                                          "no-filter": "",
                                          clearable: "",
                                          "item-text": "displayMember",
                                          "item-value": "valueMember",
                                          "return-object": "",
                                          disabled: !_vm.getZastupcaParameter(
                                            "isEnabled",
                                            "cislo_domu",
                                            zas.id_zastupcu
                                          ),
                                          rules: [
                                            _vm.getZastupcaParameter(
                                              "isRequired",
                                              "cislo_domu",
                                              zas.id_zastupcu
                                            )
                                              ? _vm.requiredRule
                                              : true
                                          ]
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.addressOnChange(
                                              $event,
                                              zas
                                            )
                                          },
                                          "update:search-input": function(
                                            $event
                                          ) {
                                            return _vm.searchAddresses(
                                              $event,
                                              zas,
                                              0
                                            )
                                          }
                                        },
                                        model: {
                                          value: zas.cislo_domu,
                                          callback: function($$v) {
                                            _vm.$set(zas, "cislo_domu", $$v)
                                          },
                                          expression: "zas.cislo_domu"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { xl: "4", lg: "4", md: "4" } },
                                    [
                                      _c("v-combobox", {
                                        staticClass: "dynamic-input-control",
                                        class: {
                                          required: _vm.getZastupcaParameter(
                                            "isRequired",
                                            "psc",
                                            zas.id_zastupcu
                                          )
                                        },
                                        attrs: {
                                          label: "PSČ",
                                          "append-icon": "mdi-chevron-down",
                                          outlined: "",
                                          items: zas.pscSearchData,
                                          loading: zas.pscSearchLoading.value,
                                          "no-filter": "",
                                          clearable: "",
                                          "item-text": "displayMember",
                                          "item-value": "valueMember",
                                          "return-object": "",
                                          rules: [
                                            function(v) {
                                              if (zas.obcianstvo !== 1) {
                                                return true
                                              }
                                              if (!v) {
                                                return true
                                              }
                                              if (!/^[0-9]*$/.exec(v)) {
                                                return "PSČ smie obsahovať iba čísla"
                                              }
                                              if (v.length != 5) {
                                                return "Nesprávne PSČ"
                                              }
                                              return true
                                            },
                                            _vm.getZastupcaParameter(
                                              "isRequired",
                                              "psc",
                                              zas.id_zastupcu
                                            )
                                              ? _vm.requiredRule
                                              : true
                                          ],
                                          disabled: !_vm.getZastupcaParameter(
                                            "isEnabled",
                                            "psc",
                                            zas.id_zastupcu
                                          )
                                        },
                                        on: {
                                          "update:search-input": function(
                                            $event
                                          ) {
                                            return _vm.searchZIP($event, zas)
                                          }
                                        },
                                        model: {
                                          value: zas.psc,
                                          callback: function($$v) {
                                            _vm.$set(zas, "psc", $$v)
                                          },
                                          expression: "zas.psc"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-form",
                        {
                          ref: "form_op_" + zas.id_zastupcu,
                          refInFor: true,
                          attrs: { autocomplete: "off" }
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !zas.zadatOpManualne,
                                  expression: "!zas.zadatOpManualne"
                                }
                              ]
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex op-cards" },
                                [
                                  _c(
                                    "v-card",
                                    { staticClass: "op-back pb-0" },
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  class: {
                                                    readonly: zas.readonly
                                                  }
                                                },
                                                [
                                                  _c("v-combobox", {
                                                    staticClass:
                                                      "dynamic-input-control naked",
                                                    class: {
                                                      readonly: zas.readonly,
                                                      required: _vm.getZastupcaParameter(
                                                        "isRequired",
                                                        "mesto",
                                                        zas.id_zastupcu
                                                      )
                                                    },
                                                    attrs: {
                                                      label: "Mesto/obec",
                                                      readonly: zas.readonly,
                                                      rules: [
                                                        _vm.getZastupcaParameter(
                                                          "isRequired",
                                                          "mesto",
                                                          zas.id_zastupcu
                                                        )
                                                          ? _vm.requiredRule
                                                          : true
                                                      ],
                                                      "append-icon":
                                                        "mdi-chevron-down",
                                                      outlined: "",
                                                      items:
                                                        zas.mestoSearchData,
                                                      loading:
                                                        zas.mestoSearchLoading
                                                          .value,
                                                      "no-filter": "",
                                                      clearable: "",
                                                      "item-text":
                                                        "displayMember",
                                                      "item-value":
                                                        "valueMember",
                                                      "return-object": "",
                                                      disabled: !_vm.getZastupcaParameter(
                                                        "isEnabled",
                                                        "mesto",
                                                        zas.id_zastupcu
                                                      )
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.cityOnChange(
                                                          $event,
                                                          zas
                                                        )
                                                      },
                                                      "update:search-input": function(
                                                        $event
                                                      ) {
                                                        return _vm.searchCity(
                                                          $event,
                                                          zas,
                                                          3
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value: zas.mesto,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          zas,
                                                          "mesto",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "zas.mesto"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _c("v-col", { attrs: { cols: "6" } }),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  class: {
                                                    readonly: zas.readonly
                                                  }
                                                },
                                                [
                                                  _c("v-combobox", {
                                                    staticClass:
                                                      "dynamic-input-control naked",
                                                    class: {
                                                      readonly: zas.readonly,
                                                      required: _vm.getZastupcaParameter(
                                                        "isRequired",
                                                        "ulica",
                                                        zas.id_zastupcu
                                                      )
                                                    },
                                                    attrs: {
                                                      label: "Ulica",
                                                      "append-icon":
                                                        "mdi-chevron-down",
                                                      outlined: "",
                                                      readonly: zas.readonly,
                                                      items:
                                                        zas.ulicaSearchData,
                                                      loading:
                                                        zas.ulicaSearchLoading
                                                          .value,
                                                      "no-filter": "",
                                                      "item-text":
                                                        "displayMember",
                                                      "item-value":
                                                        "valueMember",
                                                      clearable: "",
                                                      "return-object": "",
                                                      disabled: !_vm.getZastupcaParameter(
                                                        "isEnabled",
                                                        "ulica",
                                                        zas.id_zastupcu
                                                      ),
                                                      rules: [
                                                        _vm.getZastupcaParameter(
                                                          "isRequired",
                                                          "ulica",
                                                          zas.id_zastupcu
                                                        )
                                                          ? _vm.requiredRule
                                                          : true
                                                      ]
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.streetOnChange(
                                                          $event,
                                                          zas
                                                        )
                                                      },
                                                      "update:search-input": function(
                                                        $event
                                                      ) {
                                                        return _vm.searchStreets(
                                                          $event,
                                                          zas,
                                                          3
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value: zas.ulica,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          zas,
                                                          "ulica",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "zas.ulica"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  class: {
                                                    readonly: zas.readonly
                                                  }
                                                },
                                                [
                                                  _c("v-combobox", {
                                                    staticClass:
                                                      "dynamic-input-control naked",
                                                    class: {
                                                      readonly: zas.readonly,
                                                      required: _vm.getZastupcaParameter(
                                                        "isRequired",
                                                        "cislo_domu",
                                                        zas.id_zastupcu
                                                      )
                                                    },
                                                    attrs: {
                                                      label: "Číslo domu",
                                                      readonly: zas.readonly,
                                                      "append-icon":
                                                        "mdi-chevron-down",
                                                      outlined: "",
                                                      items:
                                                        zas.cislo_domuSearchData,
                                                      loading:
                                                        zas
                                                          .cislo_domuSearchLoading
                                                          .value,
                                                      "no-filter": "",
                                                      clearable: "",
                                                      "item-text":
                                                        "displayMember",
                                                      "item-value":
                                                        "valueMember",
                                                      "return-object": "",
                                                      disabled: !_vm.getZastupcaParameter(
                                                        "isEnabled",
                                                        "cislo_domu",
                                                        zas.id_zastupcu
                                                      ),
                                                      rules: [
                                                        _vm.getZastupcaParameter(
                                                          "isRequired",
                                                          "cislo_domu",
                                                          zas.id_zastupcu
                                                        )
                                                          ? _vm.requiredRule
                                                          : true
                                                      ]
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.addressOnChange(
                                                          $event,
                                                          zas
                                                        )
                                                      },
                                                      "update:search-input": function(
                                                        $event
                                                      ) {
                                                        return _vm.searchAddresses(
                                                          $event,
                                                          zas,
                                                          0
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value: zas.cislo_domu,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          zas,
                                                          "cislo_domu",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "zas.cislo_domu"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  class: {
                                                    readonly: zas.readonly
                                                  }
                                                },
                                                [
                                                  _c("v-combobox", {
                                                    staticClass:
                                                      "dynamic-input-control naked",
                                                    class: {
                                                      readonly: zas.readonly,
                                                      required: _vm.getZastupcaParameter(
                                                        "isRequired",
                                                        "psc",
                                                        zas.id_zastupcu
                                                      )
                                                    },
                                                    attrs: {
                                                      label: "PSČ",
                                                      readonly: zas.readonly,
                                                      "append-icon":
                                                        "mdi-chevron-down",
                                                      outlined: "",
                                                      items: zas.pscSearchData,
                                                      loading:
                                                        zas.pscSearchLoading
                                                          .value,
                                                      "no-filter": "",
                                                      clearable: "",
                                                      "item-text":
                                                        "displayMember",
                                                      "item-value":
                                                        "valueMember",
                                                      "return-object": "",
                                                      rules: [
                                                        function(v) {
                                                          if (
                                                            zas.obcianstvo !== 1
                                                          ) {
                                                            return true
                                                          }
                                                          if (!v) {
                                                            return true
                                                          }
                                                          if (
                                                            !/^[0-9]*$/.exec(v)
                                                          ) {
                                                            return "PSČ smie obsahovať iba čísla"
                                                          }
                                                          if (v.length != 5) {
                                                            return "Nesprávne PSČ"
                                                          }

                                                          return true
                                                        },
                                                        _vm.getZastupcaParameter(
                                                          "isRequired",
                                                          "psc",
                                                          zas.id_zastupcu
                                                        )
                                                          ? _vm.requiredRule
                                                          : true
                                                      ],
                                                      disabled: !_vm.getZastupcaParameter(
                                                        "isEnabled",
                                                        "psc",
                                                        zas.id_zastupcu
                                                      )
                                                    },
                                                    on: {
                                                      "update:search-input": function(
                                                        $event
                                                      ) {
                                                        return _vm.searchZIP(
                                                          $event,
                                                          zas
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value: zas.psc,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          zas,
                                                          "psc",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "zas.psc"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _c("v-col", { attrs: { cols: "6" } }),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c("text-box", {
                                                class: {
                                                  readonly: zas.readonly
                                                },
                                                attrs: {
                                                  label: "Miesto narodenia",
                                                  readonly: zas.readonly,
                                                  isEnabled: _vm.getZastupcaParameter(
                                                    "isEnabled",
                                                    "miesto_narodenia",
                                                    zas.id_zastupcu
                                                  ),
                                                  required: _vm.getZastupcaParameter(
                                                    "isRequired",
                                                    "miesto_narodenia",
                                                    zas.id_zastupcu
                                                  ),
                                                  naked: ""
                                                },
                                                model: {
                                                  value: zas.miesto_narodenia,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      zas,
                                                      "miesto_narodenia",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "zas.miesto_narodenia"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              !zas.zahranicna_osoba
                                                ? _c("text-box", {
                                                    key: zas.zahranicna_osoba,
                                                    class: {
                                                      readonly: zas.readonly
                                                    },
                                                    attrs: {
                                                      label: "Rodné priezvisko",
                                                      readonly: zas.readonly,
                                                      isEnabled: _vm.getZastupcaParameter(
                                                        "isEnabled",
                                                        "rodne_priezvisko",
                                                        zas.id_zastupcu
                                                      ),
                                                      required: _vm.getZastupcaParameter(
                                                        "isRequired",
                                                        "rodne_priezvisko",
                                                        zas.id_zastupcu
                                                      ),
                                                      naked: ""
                                                    },
                                                    model: {
                                                      value:
                                                        zas.rodne_priezvisko,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          zas,
                                                          "rodne_priezvisko",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "zas.rodne_priezvisko"
                                                    }
                                                  })
                                                : _c("text-box", {
                                                    key:
                                                      zas.zahranicna_osoba +
                                                      "x",
                                                    staticClass: "readonly",
                                                    attrs: {
                                                      naked: "",
                                                      readonly: ""
                                                    }
                                                  })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c("text-box", {
                                                class: {
                                                  readonly: zas.readonly
                                                },
                                                attrs: {
                                                  label: "Osobité záznamy",
                                                  readonly: zas.readonly,
                                                  isEnabled: _vm.getZastupcaParameter(
                                                    "isEnabled",
                                                    "osobitne_zaznamy",
                                                    zas.id_zastupcu
                                                  ),
                                                  required: _vm.getZastupcaParameter(
                                                    "isRequired",
                                                    "osobitne_zaznamy",
                                                    zas.id_zastupcu
                                                  ),
                                                  naked: ""
                                                },
                                                model: {
                                                  value: zas.osobitne_zaznamy,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      zas,
                                                      "osobitne_zaznamy",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "zas.osobitne_zaznamy"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "btn-icon btn-op-edit",
                                          class: {
                                            "btn-terciary": zas.readonly,
                                            "btn-secondary": !zas.readonly
                                          },
                                          on: {
                                            click: function($event) {
                                              zas.readonly = !zas.readonly
                                            }
                                          }
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  zas.readonly
                                                    ? "mdi-pencil-outline"
                                                    : "mdi-check"
                                                ) +
                                                " "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-card",
                                    {
                                      staticClass: "op order-first pb-0 px-25px"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex" },
                                        [
                                          _c("v-img", {
                                            staticClass: "mt-30px",
                                            attrs: {
                                              width: 123,
                                              height: 163,
                                              src: require("../assets/img/" +
                                                (zas.pohlavie === 2
                                                  ? "op_female.png"
                                                  : "op_male.png"))
                                            }
                                          }),
                                          _c(
                                            "div",
                                            { staticClass: "pl-34px" },
                                            [
                                              _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "7" } },
                                                    [
                                                      _c("text-box", {
                                                        class: {
                                                          readonly: zas.readonly
                                                        },
                                                        attrs: {
                                                          label: "Priezvisko",
                                                          readonly:
                                                            zas.readonly,
                                                          naked: "",
                                                          isEnabled: _vm.getZastupcaParameter(
                                                            "isEnabled",
                                                            "priezvisko",
                                                            zas.id_zastupcu
                                                          ),
                                                          required: _vm.getZastupcaParameter(
                                                            "isRequired",
                                                            "priezvisko",
                                                            zas.id_zastupcu
                                                          )
                                                        },
                                                        model: {
                                                          value: zas.priezvisko,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              zas,
                                                              "priezvisko",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "zas.priezvisko"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "5" } },
                                                    [
                                                      _c("date-picker", {
                                                        class: {
                                                          readonly: zas.readonly
                                                        },
                                                        attrs: {
                                                          label:
                                                            "Dátum narodenia",
                                                          readonly:
                                                            zas.readonly,
                                                          "no-icon": "",
                                                          "text-only": "",
                                                          naked: "",
                                                          isEnabled: _vm.getZastupcaParameter(
                                                            "isEnabled",
                                                            "datum_narodenia",
                                                            zas.id_zastupcu
                                                          ),
                                                          required: _vm.getZastupcaParameter(
                                                            "isRequired",
                                                            "datum_narodenia",
                                                            zas.id_zastupcu
                                                          )
                                                        },
                                                        model: {
                                                          value:
                                                            zas.datum_narodenia,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              zas,
                                                              "datum_narodenia",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "zas.datum_narodenia"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "7" } },
                                                    [
                                                      _c("text-box", {
                                                        class: {
                                                          readonly: zas.readonly
                                                        },
                                                        attrs: {
                                                          label: "Meno",
                                                          readonly:
                                                            zas.readonly,
                                                          naked: "",
                                                          isEnabled: _vm.getZastupcaParameter(
                                                            "isEnabled",
                                                            "meno",
                                                            zas.id_zastupcu
                                                          ),
                                                          required: _vm.getZastupcaParameter(
                                                            "isRequired",
                                                            "meno",
                                                            zas.id_zastupcu
                                                          )
                                                        },
                                                        model: {
                                                          value: zas.meno,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              zas,
                                                              "meno",
                                                              $$v
                                                            )
                                                          },
                                                          expression: "zas.meno"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "5" } },
                                                    [
                                                      _c("text-box", {
                                                        key: zas.rc,
                                                        class: {
                                                          readonly: zas.readonly
                                                        },
                                                        attrs: {
                                                          staticLabel: zas.zahranicna_osoba
                                                            ? "Identifikačné číslo"
                                                            : "Rodné číslo",
                                                          rodneCislo: !zas.zahranicna_osoba,
                                                          readonly:
                                                            zas.readonly,
                                                          naked: "",
                                                          isEnabled: _vm.getZastupcaParameter(
                                                            "isEnabled",
                                                            "rc",
                                                            zas.id_zastupcu
                                                          ),
                                                          required: _vm.getZastupcaParameter(
                                                            "isRequired",
                                                            "rc",
                                                            zas.id_zastupcu
                                                          )
                                                        },
                                                        on: {
                                                          input: function(v) {
                                                            return _vm.onRodneCisloInput(
                                                              v,
                                                              zas
                                                            )
                                                          }
                                                        },
                                                        model: {
                                                          value: zas.rc,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              zas,
                                                              "rc",
                                                              $$v
                                                            )
                                                          },
                                                          expression: "zas.rc"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "pr-0",
                                                      attrs: { cols: "12" }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          class: {
                                                            readonly:
                                                              zas.readonly
                                                          }
                                                        },
                                                        [
                                                          _c("v-autocomplete", {
                                                            staticClass:
                                                              "dynamic-input-control naked",
                                                            class: {
                                                              readonly:
                                                                zas.readonly,
                                                              required: _vm.getZastupcaParameter(
                                                                "isRequired",
                                                                "id_krajiny_dokladu",
                                                                zas.id_zastupcu
                                                              )
                                                            },
                                                            attrs: {
                                                              "append-icon":
                                                                "mdi-chevron-down",
                                                              outlined: "",
                                                              label: zas.zahranicna_osoba
                                                                ? "Štátna príslušnosť"
                                                                : "Štátne občianstvo",
                                                              rules: [
                                                                _vm.getZastupcaParameter(
                                                                  "isRequired",
                                                                  "id_krajiny_dokladu",
                                                                  zas.id_zastupcu
                                                                )
                                                                  ? _vm.requiredRule
                                                                  : true,
                                                                function(v) {
                                                                  return _vm.statnaPrislusnostRule(
                                                                    v,
                                                                    zas
                                                                  )
                                                                }
                                                              ],
                                                              items:
                                                                _vm.statyData,
                                                              readonly:
                                                                zas.readonly,
                                                              "item-text":
                                                                "displayMember",
                                                              "item-value":
                                                                "valueMember",
                                                              disabled: !_vm.getZastupcaParameter(
                                                                "isEnabled",
                                                                "id_krajiny_dokladu",
                                                                zas.id_zastupcu
                                                              )
                                                            },
                                                            model: {
                                                              value:
                                                                zas.id_krajiny_dokladu,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  zas,
                                                                  "id_krajiny_dokladu",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "zas.id_krajiny_dokladu"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "5" } },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          class: {
                                                            readonly:
                                                              zas.readonly
                                                          }
                                                        },
                                                        [
                                                          _c("v-autocomplete", {
                                                            staticClass:
                                                              "dynamic-input-control naked",
                                                            class: {
                                                              readonly:
                                                                zas.readonly,
                                                              required: _vm.getZastupcaParameter(
                                                                "isRequired",
                                                                "pohlavie",
                                                                zas.id_zastupcu
                                                              )
                                                            },
                                                            attrs: {
                                                              "append-icon":
                                                                "mdi-chevron-down",
                                                              outlined: "",
                                                              label: "Pohlavie",
                                                              items:
                                                                _vm.pohlaviaData,
                                                              readonly:
                                                                zas.readonly,
                                                              naked: "",
                                                              rules: [
                                                                _vm.getZastupcaParameter(
                                                                  "isRequired",
                                                                  "pohlavie",
                                                                  zas.id_zastupcu
                                                                )
                                                                  ? _vm.requiredRule
                                                                  : true
                                                              ],
                                                              "item-text":
                                                                "displayMember",
                                                              "item-value":
                                                                "valueMember",
                                                              disabled: !_vm.getZastupcaParameter(
                                                                "isEnabled",
                                                                "pohlavie",
                                                                zas.id_zastupcu
                                                              )
                                                            },
                                                            model: {
                                                              value:
                                                                zas.pohlavie,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  zas,
                                                                  "pohlavie",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "zas.pohlavie"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  ),
                                                  _c("v-col", {
                                                    attrs: { cols: "2" }
                                                  }),
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "5" } },
                                                    [
                                                      _c("date-picker", {
                                                        class: {
                                                          readonly: zas.readonly
                                                        },
                                                        attrs: {
                                                          staticLabel: zas.zahranicna_osoba
                                                            ? "Platnosť do"
                                                            : "Dátum platnosti",
                                                          readonly:
                                                            zas.readonly,
                                                          "no-icon": "",
                                                          "text-only": "",
                                                          naked: "",
                                                          isEnabled: _vm.getZastupcaParameter(
                                                            "isEnabled",
                                                            "platnost_do",
                                                            zas.id_zastupcu
                                                          ),
                                                          required: _vm.getZastupcaParameter(
                                                            "isRequired",
                                                            "platnost_do",
                                                            zas.id_zastupcu
                                                          )
                                                        },
                                                        model: {
                                                          value:
                                                            zas.platnost_do,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              zas,
                                                              "platnost_do",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "zas.platnost_do"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "5" } },
                                                    [
                                                      _c("text-box", {
                                                        class: {
                                                          readonly: zas.readonly
                                                        },
                                                        attrs: {
                                                          staticLabel: zas.zahranicna_osoba
                                                            ? "Číslo dokladu"
                                                            : "Číslo OP",
                                                          readonly:
                                                            zas.readonly,
                                                          naked: "",
                                                          isEnabled: _vm.getZastupcaParameter(
                                                            "isEnabled",
                                                            "cislo_dokladu",
                                                            zas.id_zastupcu
                                                          ),
                                                          required: _vm.getZastupcaParameter(
                                                            "isRequired",
                                                            "cislo_dokladu",
                                                            zas.id_zastupcu
                                                          )
                                                        },
                                                        model: {
                                                          value:
                                                            zas.cislo_dokladu,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              zas,
                                                              "cislo_dokladu",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "zas.cislo_dokladu"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c("v-col", {
                                                    attrs: { cols: "2" }
                                                  }),
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "5" } },
                                                    [
                                                      _c("date-picker", {
                                                        class: {
                                                          readonly: zas.readonly
                                                        },
                                                        attrs: {
                                                          label:
                                                            "Dátum vydania",
                                                          readonly:
                                                            zas.readonly,
                                                          "no-icon": "",
                                                          "text-only": "",
                                                          naked: "",
                                                          isEnabled: _vm.getZastupcaParameter(
                                                            "isEnabled",
                                                            "platnost_od",
                                                            zas.id_zastupcu
                                                          ),
                                                          required: _vm.getZastupcaParameter(
                                                            "isRequired",
                                                            "platnost_od",
                                                            zas.id_zastupcu
                                                          )
                                                        },
                                                        on: {
                                                          inputChanged: function(
                                                            v
                                                          ) {
                                                            return _vm.updateDatumPlatnosti(
                                                              v,
                                                              zas
                                                            )
                                                          }
                                                        },
                                                        model: {
                                                          value:
                                                            zas.platnost_od,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              zas,
                                                              "platnost_od",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "zas.platnost_od"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            )
          }),
          _c(
            "v-btn",
            {
              staticClass: "btn-secondary mt-20px",
              attrs: { disabled: _vm.addZastupcaDisabled },
              on: {
                click: function($event) {
                  return _vm.addZastupca()
                }
              }
            },
            [_vm._v("Pridať novú kontaktnú osobu")]
          ),
          _c(
            "v-btn",
            {
              staticClass: "btn-primary mt-20px right",
              on: {
                click: function($event) {
                  return _vm.ulozit()
                }
              }
            },
            [_vm._v("Uložiť")]
          ),
          _c(
            "v-btn",
            {
              staticClass: "btn-secondary mt-20px mr-20px right",
              attrs: { to: "/obchodne-pripady" }
            },
            [_vm._v("Zatvoriť")]
          ),
          _c("kontrola-pred-schvalenim", {
            ref: "kontrolaPredSchvalenim",
            attrs: {
              cisloObchPripadu: this.odoslatNaSchvalenieRequest
                .cisloObchPripadu,
              cisloPredmetu: this.odoslatNaSchvalenieRequest.cisloPredmetu,
              newId: this.odoslatNaSchvalenieRequest.newId,
              formaPodnikania: _vm.formaPodnikania
            }
          }),
          _c(
            "v-dialog",
            {
              attrs: {
                "overlay-color": "#000",
                "overlay-opacity": "0.66",
                persistent: "",
                "max-width": "500"
              },
              model: {
                value: _vm.sendOpMobilDialog,
                callback: function($$v) {
                  _vm.sendOpMobilDialog = $$v
                },
                expression: "sendOpMobilDialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "d-flex justify-space-between" },
                    [
                      _vm._v(
                        " Zadajte tel. číslo pre nahratie " +
                          _vm._s(
                            _vm.sendOpMobilZastupca != null
                              ? _vm.sendOpMobilZastupca.zahranicnaOsoba
                                ? "dokladu"
                                : "občianského preukazu"
                              : "občianského preukazu"
                          ) +
                          " "
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function($event) {
                              return _vm.closeSendOpMobilDialog()
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    [
                      _c("text-box", {
                        ref: "opTelCislo",
                        attrs: {
                          rules: [_vm.telefonneCisloRule],
                          label: "Zadajte tel. číslo",
                          placeholder: "+421",
                          required: "",
                          textOnFocus: "+421",
                          removeCharacters: /[^+\d]/g,
                          isPhoneNumber: true,
                          cache: false
                        },
                        model: {
                          value: _vm.opTelefon,
                          callback: function($$v) {
                            _vm.opTelefon = $$v
                          },
                          expression: "opTelefon"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-secondary ml-5",
                          on: {
                            click: function($event) {
                              return _vm.closeSendOpMobilDialog()
                            }
                          }
                        },
                        [_vm._v(" Späť ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-primary",
                          on: {
                            click: function($event) {
                              return _vm.sendOpMobil()
                            }
                          }
                        },
                        [_vm._v(" Odoslať ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }